<div class="how-it-works-banner">
  <div class="shippn-homepage-container container">
    <div class="row">
      <div class="col-md-12">
        <h1 class="background-text"
          style="text-align: center;font-weight: bold;margin-bottom: 100px;color: white;margin-top: 125px;">
          Global Commerce Insights: How Shippn Works for Shoppers
        </h1>
      </div>
    </div>
  </div>
</div>



<section class="how-it-works-section">

  <div class="shippn-homepage-container container how-it-works-container">
    <div class="how-it-works-header">
      <div class="how-it-works-header-content">
        <p>
          <span class="color-orange">Shippn</span> is a community of trusted members helping each other unlock
          a world of opportunities to shop
          from
          anywhere in the world.
        </p>
      </div>
      <div class="how-it-works-header-image">
        <img src="../../assets/img/how-it-works/for-host/how-it-works-host-shop-anywhere.jpg"
          alt="Shippn Shop Anywhere To Everywhere">
      </div>
    </div>
    <div class="how-it-works-header">
      <div class="how-it-works-header-image">
        <img src="../../assets/img/how-it-works/for-host/how-it-works-host-head-one.jpeg"
          alt="Shippn Shop Anywhere To Everywhere">

      </div>
      <div class="how-it-works-header-content">
        <p>
          At <span class="color-orange">Shippn</span> there are shoppers and hosts. Shoppers need help
          shopping from abroad
          to overcome issues with international delivery, hosts are individuals who can provide their address
          for
          shopping and help with international package forwarding.
        </p>

      </div>

    </div>
    <div class="how-it-works-header-action">
      <p class="head-paragraph">
        You can become a member at <span class="color-orange">Shippn</span> and instantly start shopping the world.
      </p>
      <button class="btn btn-orange" [routerLink]="['/', 'signup']">Sign Up Now</button>
    </div>
  </div>


</section>

<!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
  <path fill="#f4f4f4" fill-opacity="1"
    d="M0,0L48,5.3C96,11,192,21,288,53.3C384,85,480,139,576,144C672,149,768,107,864,122.7C960,139,1056,213,1152,250.7C1248,288,1344,288,1392,288L1440,288L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
  </path>
</svg> -->
<section class="how-it-works-section bg-white-grey pad-top-0">
  <div class="shippn-homepage-container container how-it-works-container">
    <div class="how-it-works-explanation-wrapper">
      <div class="how-it-works-explanation-item">
        <div class="how-it-works-explanation-item-image">
          <img src="../../assets/img/how-it-works/for-shopper/how-it-works-shopper-choose-host.png"
            alt="Shippn how it works for host image">
          <!-- <img src="../../assets/img/how-it-works-for-hosts-icon.png" alt="Shippn how it works for host image"> -->
        </div>
        <div class="how-it-works-explanation-item-content">
          <h4 class=" color-orange">
            Choose Your Host.
          </h4>
          <p>
            Shippn hosts share their spaces in {{hostCountriesCount}}+ countries and more than 50 cities. All you have to do is select the
            country you want to shop from and choose your host to forward your package, anywhere in the world.
          </p>
          <!-- <button (click)="goBecomeAHost()" class="btn btn-orange">Become a Host</button> -->
        </div>
      </div>
      <div class="how-it-works-explanation-item direction-left">

        <div class="how-it-works-explanation-item-content">
          <h4 class=" color-orange">
            Fill Package details.
          </h4>
          <p>
            Fill in the details of your package like weight, dimensions and content and Shippn will give you an
            estimation of the shipping cost. This way you will know your costs even before you purchase your item.
          </p>
        </div>
        <div class="how-it-works-explanation-item-image">
          <img src="../../assets/img/how-it-works/for-shopper/how-it-works-shopper-fill.webp"
            alt="Shippn How it works hosts 2">
        </div>
      </div>
      <div class="how-it-works-explanation-item">
        <div class="how-it-works-explanation-item-image">
          <img src="../../assets/img/how-it-works/for-shopper/how-it-works-shopper-shopping.jpg"
            alt="Shippn How it works hosts 2">
        </div>
        <div class="how-it-works-explanation-item-content">
          <h4 class="color-orange">

            Get your local address and start shopping!
          </h4>
          <p>
            Get your address instantly at Shippn and start shopping from your favorite brands. Make sure to use your new
            Shippn address as "Ship to" address and get an instant notification when your package arrives at your host's
            address.
          </p>
        </div>
      </div>

      <div class="how-it-works-explanation-item direction-left">

        <div class="how-it-works-explanation-item-content">
          <h4 class="color-orange">

            Get your package shipped.
          </h4>
          <p>
            Once your package is in your host's Mailbox, you can adjust your preferences for shipping such as assisted
            customs clearance. Then you can confirm your order and your package will be shipped.
          </p>
        </div>
        <div class="how-it-works-explanation-item-image">
          <img src="../../assets/img/how-it-works/for-shopper/how-it-works-shopper-package-shipped.jpg"
            alt="Shippn How it works hosts 2">
        </div>
      </div>
      <div class="how-it-works-explanation-item">
        <div class="how-it-works-explanation-item-image">
          <img src="../../assets/img/how-it-works/for-shopper/how-it-works-shopper-doorway.webp"
            alt="Shippn How it works hosts 2">
        </div>
        <div class="how-it-works-explanation-item-content">
          <h4 class="color-orange">

            Your package on your doorway!
          </h4>
          <p>
            Receive your package in 1-5 business days* via trusted logistics partners DHL, UPS and FEDEX and enjoy the
            convenience of shopping the world with Shippn.
          </p>
        </div>
      </div>
    </div>

    <div class="how-it-works-actions-wrapper">
      <div style="text-align: center;" class="col-md-12">
        <!-- <button (click)="goBecomeAHost()" class="btn btn-orange">Become a Host</button> -->
      </div>
    </div>

    <div class="how-it-works-additional-wrapper">
      <button class="btn btn-orange" [routerLink]="['/', 'shop-from']">Start Shopping</button>
    </div>
  </div>
</section>

<div class="how-it-works-footer-country-selection">
  <div class="shippn-homepage-container container">
    <div class="row">
      <div style="text-align: left;" class="col-md-8">
        <h4 style="color: white;font-weight: bold;text-align: left;">How to Shop from any country with Shippn?</h4>
        <small style="color: white;">* Delivery times differ for country of origin and destination countries.</small>
      </div>
      <div class="col-md-4 mobile-text-center-desktop-right">
        <div
          style="border-radius: 5px;margin-top: 5px; margin-bottom: 5px; background-color: white;position:relative; width: 200px; margin: auto;"
          class="select--wrapper">
          <i class="fas fa-chevron-down"
            style="position: absolute; right: 10px; top: 12px;float: right; color: #222222; border-radius: 32%; padding: 7px; font-size: 12px;"
            aria-hidden="true"></i>
          <select (change)="goCountry()" [(ngModel)]="selectedCountry"
            style="-webkit-appearance: none;-moz-appearance: none;appearance: none;width: 200px; border-radius: 5px;padding: 14px;font-size: 13px;">
            <option value="">Select Country</option>
            <option *ngFor="let countriesWithHost of hostCountryList;" value="{{countriesWithHost.code}}">
              <span *ngIf="countriesWithHost?.code != 'TR' && countriesWithHost?.name != 'Turkey'">{{countriesWithHost?.name}}</span>
              <span *ngIf="countriesWithHost?.code == 'TR' || countriesWithHost?.name == 'Turkey'" translate="no">Türkiye</span>
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</div>